import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";

const isProduction = process.env.ENV === "prod";

export const SplashScreen = () => {
	return (
		<Stack
			sx={{
				position: "absolute",
				inset: "0 0 0 0",
				justifyContent: "center",
				alignItems: "center",
				gap: 2,
			}}>
			<img
				src="/images/favicon.png"
				width="200px"
			/>
			<CircularProgress />
			<Chip
				label={[process.env.VERSION, !isProduction && process.env.ENV]
					.filter(Boolean)
					.join("-")}
			/>
		</Stack>
	);
};
